{
  "list": {
    "title": "วลีอัจฉริยะ",
    "backToDashboard": "แดชบอร์ด",
    "newButton": "วลีใหม่",
    "import": "นำเข้า",
    "export": "ส่งออก",
    "searchPlaceholder": "ค้นหาด้วยคีย์หรือข้อความขยาย...",
    "filterAllCategories": "ทุกหมวดหมู่",
    "header": "วลี ({{count}})",
    "loading": "กำลังโหลดวลี...",
    "empty": "ไม่พบวลี โปรดสร้างวลีอัจฉริยะแรกของคุณ",
    "authoredBy": "โดย {{name}}",
    "tooltips": {
      "preview": "ดูตัวอย่าง",
      "edit": "แก้ไข",
      "delete": "ลบ"
    },
    "confirmDelete": "ยืนยัน",
    "cancelDelete": "ยกเลิก",
    "previewLabel": "ตัวอย่าง:",
    "closePreview": "ปิดตัวอย่าง",
    "toast": {
      "deleted": "ลบวลีแล้ว",
      "importComingSoon": "ฟังก์ชันนำเข้ากำลังจะมา",
      "exportComingSoon": "ฟังก์ชันส่งออกกำลังจะมา"
    }
  },
  "form": {
    "editTitle": "แก้ไขวลีอัจฉริยะ",
    "createTitle": "วลีอัจฉริยะใหม่",
    "fields": {
      "key": "คีย์",
      "category": "หมวดหมู่",
      "expansionText": "ข้อความขยาย"
    },
    "required": "*",
    "keyPlaceholder": ".normalexam",
    "keyHelper": "ต้องเริ่มต้นด้วย \".\"",
    "categoryUncategorized": "ไม่ระบุหมวดหมู่",
    "expansionPlaceholder": "ข้อความที่จะแทนที่ทางลัด...",
    "cancel": "ยกเลิก",
    "create": "สร้างวลี",
    "update": "อัปเดตวลี",
    "toast": {
      "created": "สร้างวลีแล้ว",
      "updated": "อัปเดตวลีแล้ว",
      "saveFailed": "บันทึกวลีไม่สำเร็จ",
      "keyMustStartWithDot": "คีย์ต้องเริ่มต้นด้วย \".\"",
      "keyTooShort": "คีย์ต้องยาวอย่างน้อย 2 ตัวอักษร",
      "expansionRequired": "ต้องระบุข้อความขยาย"
    }
  },
  "category": {
    "general": "ทั่วไป",
    "physicalExam": "ตรวจร่างกาย",
    "reviewOfSystems": "ทบทวนระบบ",
    "assessment": "การประเมิน",
    "plan": "แผนการรักษา",
    "instructions": "คำแนะนำ",
    "medications": "ยา",
    "history": "ประวัติ"
  }
}
